import http from "./base";

export default {
    index(queryString) {
        return http().get('/contracts' + (queryString !== undefined ? '?' + queryString : ''))
    },
    show(id) {
        return http().get('/contracts/' + id)
    },
}
